module.exports = "/_next/static/images/758db5cbadaadc308657673dad6afba3-background@2x.png.webp";